import { store } from "@src/index";
import { IOrganization } from "@src/types/api";

import { getOrganizations, getUser } from "@api";

import { globalActions } from "@features/global/globalSlice";
import { userActions } from "@features/user/userSlice";

import { buildKey, loaderCache } from "@services/loaderCache";

const loader = async ({ params }: { params: any }) => {
    const orgsKey = buildKey("organizations", "organizations");

    const cachedOrgs = loaderCache.get<IOrganization[]>(orgsKey);

    let { orgId } = params;
    const { auth } = store.getState();

    // If no orgId is provided, default to the user's organization
    // This is for when an org user accesses their org management page and no orgId is in the URL
    if (!orgId) {
        const { user: userInfo } = await getUser(auth.user!.id);
        orgId = userInfo.organization;
    }

    const promises: Promise<any>[] = [];

    const users = store.getState().user.users;
    const settings = store.getState().global.settings;

    !cachedOrgs && promises.push(getOrganizations());
    !users.length && promises.push(store.dispatch(userActions.getUsers()));
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    const results = await Promise.all(promises);
    let resultsIndex = 0;
    let organizations: IOrganization[] | null = cachedOrgs;

    if (!cachedOrgs) {
        organizations = results[resultsIndex].organizations;
        loaderCache.set(orgsKey, organizations);
        resultsIndex++;
    }

    const organization = organizations?.find(org => org.id === Number(orgId));

    return {
        orgId,
        organization: organization ?? undefined,
    };
};

export default loader;
